<template>
  <div class="content">商家扫一扫


    <businessTabbar></businessTabbar>
  </div>

</template>

<script>
import businessTabbar from "@/components/businessTabbar";
export default {
  name: "scan",
  data(){
    return {

    }
  },
  components: {
    businessTabbar
  }
}
</script>

<style scoped>

</style>
